(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mf-announcement"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (customElements.get('mf-announcement')) return;
    class MfAnnouncement extends HTMLElement {
      connectedCallback() {
        this.ac = new AbortController();
        var sig = { signal: this.ac.signal };
        var self = this;
        this.slides = Array.prototype.slice.call(this.querySelectorAll('[data-slide]'));
        this.index = 0;
        this.addEventListener('mouseenter', function () { self.stop(); }, sig);
        this.addEventListener('mouseleave', function () { self.start(); }, sig);
        this.addEventListener('focusin', function () { self.stop(); }, sig);
        this.addEventListener('focusout', function () { self.start(); }, sig);
        document.addEventListener('shopify:block:select', function (e) {
          var i = self.slides.findIndex(function (s) { return (s.getAttribute('data-shopify-editor-block') || '').indexOf(e.detail && e.detail.blockId) > -1; });
          if (i > -1) { self.stop(); self.show(i); }
        }, sig);
        document.addEventListener('shopify:block:deselect', function () { self.start(); }, sig);
        this.start();
      }
      show(i) {
        this.index = (i + this.slides.length) % this.slides.length;
        var idx = this.index;
        this.slides.forEach(function (s, n) {
          s.classList.toggle('is-active', n === idx);
          if (n === idx) s.removeAttribute('aria-hidden'); else s.setAttribute('aria-hidden', 'true');
        });
      }
      start() {
        this.stop();
        if (this.slides.length < 2) return;
        var self = this;
        this.timer = setInterval(function () { self.show(self.index + 1); }, (parseInt(this.dataset.speed, 10) || 5) * 1000);
      }
      stop() { clearInterval(this.timer); }
      disconnectedCallback() { this.stop(); if (this.ac) this.ac.abort(); }
    }
    customElements.define('mf-announcement', MfAnnouncement);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mf-faq"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.__mfFaqBound) return; window.__mfFaqBound = true;
    document.addEventListener('shopify:block:select', function (e) {
      var d = document.querySelector('.mf-faq__item[data-block-id="' + (e.detail && e.detail.blockId) + '"]');
      if (d) d.open = true;
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mf-recently-viewed"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (customElements.get('mf-recently-viewed')) return;
    var KEY = 'mf_recently_viewed';
    function read() { try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch (e) { return []; } }
    function write(v) { try { localStorage.setItem(KEY, JSON.stringify(v)); } catch (e) {} }
    class MfRecentlyViewed extends HTMLElement {
      connectedCallback() {
        this.ac = new AbortController();
        var current = this.dataset.current, limit = parseInt(this.dataset.limit, 10) || 4;
        var list = read().filter(function (h) { return h !== current; });
        if (current) write([current].concat(list).slice(0, 12));
        var show = list.slice(0, limit);
        if (!show.length) return;
        var grid = this.querySelector('[data-grid]');
        var self = this;
        Promise.all(show.map(function (h) {
          return fetch('/products/' + encodeURIComponent(h) + '?view=card-mf&_mc=' + Date.now(), { cache: 'no-store', signal: self.ac.signal })
            .then(function (r) { return r.ok ? r.text() : ''; }).catch(function () { return ''; });
        })).then(function (cards) {
          var html = cards.filter(Boolean).join('');
          if (!html) return;
          grid.innerHTML = html;
          self.hidden = false;
        });
      }
      disconnectedCallback() { if (this.ac) this.ac.abort(); }
    }
    customElements.define('mf-recently-viewed', MfRecentlyViewed);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mf-slideshow"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (customElements.get('mf-slideshow')) return;
    class MfSlideshow extends HTMLElement {
      connectedCallback() {
        this.ac = new AbortController();
        var sig = { signal: this.ac.signal };
        this.track = this.querySelector('[data-track]');
        this.bars = Array.prototype.slice.call(this.querySelectorAll('[data-go]'));
        this.count = this.track ? this.track.children.length : 0;
        this.index = 0;
        var self = this;
        this.bars.forEach(function (b) { b.addEventListener('click', function () { self.go(parseInt(b.dataset.go, 10)); self.restart(); }, sig); });
        this.track.addEventListener('scroll', function () {
          var i = Math.round(self.track.scrollLeft / (self.track.clientWidth || 1));
          if (i !== self.index) { self.index = i; self.paint(); }
        }, { signal: this.ac.signal, passive: true });
        this.addEventListener('mouseenter', function () { self.stop(); }, sig);
        this.addEventListener('mouseleave', function () { self.restart(); }, sig);
        this.addEventListener('focusin', function () { self.stop(); }, sig);
        document.addEventListener('shopify:block:select', function (e) {
          var slide = self.querySelector('[data-shopify-editor-block*="' + (e.detail && e.detail.blockId) + '"]');
          if (!slide) return;
          self.stop(); self.go(Array.prototype.indexOf.call(self.track.children, slide));
        }, sig);
        document.addEventListener('shopify:block:deselect', function () { self.restart(); }, sig);
        this.restart();
      }
      go(i) {
        if (!this.count) return;
        this.index = (i + this.count) % this.count;
        this.track.scrollTo({ left: this.index * this.track.clientWidth, behavior: 'smooth' });
        this.paint();
      }
      paint() { var idx = this.index; this.bars.forEach(function (b, i) { b.setAttribute('aria-current', i === idx ? 'true' : 'false'); }); }
      stop() { clearInterval(this.timer); }
      restart() {
        this.stop();
        if (this.dataset.autoplay !== 'true' || this.count < 2) return;
        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
        var self = this;
        this.timer = setInterval(function () { self.go(self.index + 1); }, (parseInt(this.dataset.speed, 10) || 5) * 1000);
      }
      disconnectedCallback() { this.stop(); if (this.ac) this.ac.abort(); }
    }
    customElements.define('mf-slideshow', MfSlideshow);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mf-testimonials"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (customElements.get('mf-testimonials')) return;
    class MfTestimonials extends HTMLElement {
      connectedCallback() {
        this.ac = new AbortController();
        var sig = { signal: this.ac.signal };
        var self = this;
        this.track = this.querySelector('[data-track]');
        this.slides = Array.prototype.slice.call(this.querySelectorAll('[data-slide]'));
        this.dots = Array.prototype.slice.call(this.querySelectorAll('[data-go]'));
        if (!this.track || !this.slides.length) return;
        this.dots.forEach(function (d) { d.addEventListener('click', function () { self.go(parseInt(d.dataset.go, 10)); }, sig); });
        var raf = 0;
        this.track.addEventListener('scroll', function () { cancelAnimationFrame(raf); raf = requestAnimationFrame(function () { self.sync(); }); }, { signal: this.ac.signal, passive: true });
        window.addEventListener('resize', function () { self.go(self.index || 0, true); }, sig);
        document.addEventListener('shopify:block:select', function (e) {
          var el = self.querySelector('[data-shopify-editor-block*="' + (e.detail && e.detail.blockId) + '"]');
          if (el) self.go(parseInt(el.dataset.index, 10));
        }, sig);
        this.index = this.slides.length > 2 ? 1 : 0;
        requestAnimationFrame(function () { self.go(self.index, true); });
      }
      go(i, instant) {
        i = Math.max(0, Math.min(this.slides.length - 1, i));
        var slide = this.slides[i];
        var left = slide.offsetLeft - (this.track.clientWidth - slide.offsetWidth) / 2;
        this.track.scrollTo({ left: left, behavior: instant ? 'auto' : 'smooth' });
        this.mark(i);
      }
      sync() {
        var mid = this.track.scrollLeft + this.track.clientWidth / 2, best = 0, dist = Infinity;
        this.slides.forEach(function (s, i) { var c = s.offsetLeft + s.offsetWidth / 2, d = Math.abs(c - mid); if (d < dist) { dist = d; best = i; } });
        this.mark(best);
      }
      mark(i) {
        this.index = i;
        this.slides.forEach(function (s, n) { s.classList.toggle('is-selected', n === i); });
        this.dots.forEach(function (d, n) { d.setAttribute('aria-current', n === i ? 'true' : 'false'); });
      }
      disconnectedCallback() { if (this.ac) this.ac.abort(); }
    }
    customElements.define('mf-testimonials', MfTestimonials);
  })();

  } catch(e) { console.error(e); }
})();
})();
